var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { siteIDs } from '../../adapters/utils';
import { buildLink, buildOgMeta, buildOgMetaRefs, buildStandardMeta, buildTitle, buildTwitterMeta, } from '../../types/builders';
import { IDs } from './adapter-bookings-calendar';
var SITE_NAME = siteIDs.SITE_NAME;
var SERVICE_NAME = IDs.SERVICE_NAME, PAGE_URL = IDs.PAGE_URL;
export var BOOKINGS_CALENDAR = {
    tags: __spreadArray(__spreadArray([], buildOgMetaRefs(), true), [
        buildTitle("{{".concat(SERVICE_NAME, "}} - {{").concat(SITE_NAME, "}}")),
        buildStandardMeta('robots', 'noindex'),
        buildLink({ rel: 'canonical', href: "{{".concat(PAGE_URL, "}}") }),
        buildOgMeta('og:title', "{{".concat(SERVICE_NAME, "}}")),
        buildOgMeta('og:url', "{{".concat(PAGE_URL, "}}")),
        buildOgMeta('og:site_name', "{{".concat(SITE_NAME, "}}")),
        buildOgMeta('og:type', 'website'),
        buildTwitterMeta('twitter:card', 'summary'),
        buildTwitterMeta('twitter:title', "{{".concat(SERVICE_NAME, "}}")),
    ], false),
};
